import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import BookingWidget from '../../BookingWidget'
import InpathWidget from '../../BookingWidget/InpathWidget'

const BookingChoices = ({
  dictionary,
  pickUpDetails,
  dropOffDetails,
  inpath,
}) => {
  const [showBookingWidget, setShowBookingWidget] = useState(false)
  const [userId, setUserId] = useState(
    window.headerData?.milesNBonusAccount?.fFN || ''
  )
  const { latestSearch, type } = useSelector((state) => state.booking)

  const isInpathContext = inpath || type === 'inpath'

  const getEffectiveDetails = (baseDetails, latest, isPickup) => {
    if (!isInpathContext || !latest) return baseDetails

    const latestLocation = isPickup
      ? latest.pickUpLocation
      : latest.dropOffLocation
    const latestDate = isPickup ? latest.pickUpDate : latest.dropOffDate
    const latestTime = isPickup ? latest.pickUpTime : latest.dropOffTime

    return {
      ...baseDetails,
      address: latestLocation?.text || baseDetails?.address || '',
      date: latestDate
        ? dayjs(latestDate).format('DD/MM/YYYY')
        : baseDetails?.date || '',
      time: latestTime || baseDetails?.time || '',
    }
  }

  const effectivePickUpDetails = getEffectiveDetails(
    pickUpDetails,
    latestSearch,
    true
  )

  const effectiveDropOffDetails = getEffectiveDetails(
    dropOffDetails,
    latestSearch,
    false
  )

  if (!pickUpDetails || !dropOffDetails) return null

  useEffect(() => {
    const handleShowWidget = () => {
      setShowBookingWidget(true)
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    window.addEventListener('showBookingWidget', handleShowWidget)

    return () => {
      window.removeEventListener('showBookingWidget', handleShowWidget)
    }
  }, [])

  useEffect(() => {
    const handleLoginSuccess = (event) => {
      setUserId(event.detail.isLoggedIn ? event.detail.userId : '')
    }
    window.addEventListener('loggedIn', handleLoginSuccess)

    return () => {
      window.removeEventListener('loggedIn', handleLoginSuccess)
    }
  }, [])

  const hasInitFetchRunRef = useRef(false)

  const inpathWidgetRefCallback = useCallback((node) => {
    if (node && !hasInitFetchRunRef.current) {
      hasInitFetchRunRef.current = true
      node.initFindCars()
    }
  }, [])

  return (
    <div
      className={`s-booking-choices ${
        showBookingWidget ? 's-booking-choices--widget' : ''
      }`}>
      {showBookingWidget ? (
        <>
          {inpath ? (
            <InpathWidget handleCancel={() => setShowBookingWidget(false)} />
          ) : (
            <BookingWidget
              userId={userId}
              editMode
              handleCancel={() => setShowBookingWidget(false)}
            />
          )}
        </>
      ) : (
        <div className="page-container">
          <div className="row s-booking-choices__row">
            <div className="col-lg-3 s-booking-choices__item">
              <span className="s-booking-choices__title">
                {dictionary.pickUpLocationLabel}
              </span>
              <span className="s-booking-choices__address">
                {effectivePickUpDetails.address}
              </span>
            </div>
            <div className="col-lg-3 s-booking-choices__item">
              <span className="s-booking-choices__title">
                {dictionary.dropOffLocationLabel}
              </span>
              <span className="s-booking-choices__address">
                {effectiveDropOffDetails.address}
              </span>
            </div>
            <div className="col-lg-2 s-booking-choices__item">
              <span className="s-booking-choices__title">
                {dictionary.pickUpDateTimeLabel}
              </span>
              <span className="s-booking-choices__date">
                {effectivePickUpDetails.date},
              </span>
              <span className="s-booking-choices__time">
                {effectivePickUpDetails.time}
              </span>
            </div>
            <div className="col-lg-2 s-booking-choices__item">
              <span className="s-booking-choices__title">
                {dictionary.dropOffDateTimeLabel}
              </span>
              <span className="s-booking-choices__date">
                {effectiveDropOffDetails.date},
              </span>
              <span className="s-booking-choices__time">
                {effectiveDropOffDetails.time}
              </span>
            </div>
            <div className="col-lg-2 s-booking-choices__button">
              <button
                type="button"
                className="btn"
                onClick={() => setShowBookingWidget(true)}
                title={dictionary.editYourChoices}>
                {dictionary.editYourChoices}
              </button>
            </div>
          </div>
        </div>
      )}

      {inpath && !showBookingWidget && (
        <div style={{ display: 'none' }}>
          <InpathWidget ref={inpathWidgetRefCallback} handleCancel={() => {}} />
        </div>
      )}
    </div>
  )
}

export default BookingChoices
